import { createGlobalStyle, css } from 'styled-components';

function columnGenerator(suffix) {
	let style = '';

	for (let i = 1; i <= 12; i++) {
		style += suffix ? `.col-${suffix}-${i}` : `.col-${i}`;
		style += `{ width: ${(100 / 12) * i}% }`;
	}

	return style;
}

const HelperClass = createGlobalStyle`${css`
	/* //! Fonts */
	/* //! Neue */
	.font-neue-thin {
		font-family: var(--neue);
		font-weight: 100;
	}

	.font-neue-light {
		font-family: var(--neue);
		font-weight: 300;
	}

	.font-neue-light-italic {
		font-family: var(--neue);
		font-weight: 300;
		font-style: italic;
	}

	.font-neue-roman {
		font-family: var(--neue);
		font-weight: 400;
	}

	.font-neue-italic {
		font-family: var(--neue);
		font-weight: 400;
		font-style: italic;
	}

	.font-neue-medium {
		font-family: var(--neue);
		font-weight: 500;
	}

	.font-neue-medium-italic {
		font-family: var(--neue);
		font-weight: 500;
		font-style: italic;
	}

	.font-neue-bold {
		font-family: var(--neue);
		font-weight: 700;
	}

	.font-neue-bold-italic {
		font-family: var(--neue);
		font-weight: 700;
		font-style: italic;
	}

	/* //! OGG */
	.font-ogg-light {
		font-family: var(--ogg);
		font-weight: 300;
	}

	.font-ogg-regular {
		font-family: var(--ogg);
		font-weight: 400;
	}

	.font-ogg-regular-italic {
		font-family: var(--ogg);
		font-weight: 400;
		font-style: italic;
	}

	.font-ogg-medium {
		font-family: var(--ogg);
		font-weight: 500;
	}

	.font-ogg-medium-italic {
		font-family: var(--ogg);
		font-weight: 500;
		font-style: italic;
	}

	/* //! Colors */
	.black-1000 {
		color: var(--black1000);

		&-bg {
			background-color: var(--black1000);
		}
	}

	.black-900 {
		color: var(--black900);

		&-bg {
			background-color: var(--black900);
		}
	}

	.gray-1000 {
		color: var(--gray1000);

		&-bg {
			background-color: var(--gray1000);
		}
	}

	.light-gray-1000 {
		color: var(--lightGray1000);

		&-bg {
			background-color: var(--lightGray1000);
		}
	}

	.white-1000 {
		color: var(--white1000);

		&-bg {
			background-color: var(--white1000);
		}
	}

	.error-1000 {
		color: var(--error1000);

		&-bg {
			background-color: var(--error1000);
		}
	}

	//! Grid
	.row {
		display: flex;
		flex-wrap: wrap;
		margin: 0 calc(var(--colPadding) * -1);

		> * {
			width: 100%;
			padding: 0 var(--colPadding);
		}

		${columnGenerator()};

		//! 1920
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeXLMin}) {
			${columnGenerator('dxl')}
		}

		//! 1536
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeLMin}) {
			${columnGenerator('dl')}
		}

		//! 1366
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeMMin}) {
			${columnGenerator('dm')}
		}

		//! 1280
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeSMin}) {
			${columnGenerator('ds')}
		}

		//! 1024
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeMin}) {
			${columnGenerator('t')}
		}

		//! 768
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeXMin}) {
			${columnGenerator('dx')}
		}

		//! Mobile
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeSMin}) {
			${columnGenerator('m')}
		}
	}

	/* //! Hover Animation Styles */
	.btn-hover-relative-block {
		position: relative;
		overflow: hidden;
		width: fit-content;

		.anim-state1,
		.anim-state2 {
			display: flex;
			align-items: center;
			width: 100%;
			height: 100%;
			transition: var(--trTime) ease-out;
			will-change: transform;
		}

		.anim-state2 {
			position: absolute;
			bottom: -100%;
			left: 0;
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					.anim-state2 {
						bottom: 0;
					}

					.anim-state1 {
						transform: translateY(-100%);
					}
				}
			}
		}
	}

	/* //! Text Lines Animations */
	.text-lines-wrapper {
		overflow: hidden;

		.text-lines {
			will-change: transform;
		}
	}
`}`;

export default HelperClass;
